import request from '@/utils/request'


// 查询用户积分签到规则列表
export function listScoreSignRule(query) {
  return request({
    url: '/biz/admin/user/score/sign/rule/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询用户积分签到规则分页
export function pageScoreSignRule(query) {
  return request({
    url: '/biz/admin/user/score/sign/rule/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户积分签到规则详细
export function getScoreSignRule(data) {
  return request({
    url: '/biz/admin/user/score/sign/rule/detail',
    method: 'get',
    params: data
  })
}

// 新增用户积分签到规则
export function addScoreSignRule(data) {
  return request({
    url: '/biz/admin/user/score/sign/rule/add',
    method: 'post',
    data: data
  })
}

// 修改用户积分签到规则
export function updateScoreSignRule(data) {
  return request({
    url: '/biz/admin/user/score/sign/rule/edit',
    method: 'post',
    data: data
  })
}

// 删除用户积分签到规则
export function delScoreSignRule(data) {
  return request({
    url: '/biz/admin/user/score/sign/rule/delete',
    method: 'post',
    data: data
  })
}
